// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoBox_container__QG0O5","content":"InfoBox_content__I6IRI"};